
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import { ControlCode } from "@/oxygen/classes/lib/types";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import CodeInput from "@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue";

@Component({
  components: {
    CodeInput,
    TextInput
  }
})
export default class OxygenCodeInput extends Vue {
  @Prop()
  control!: ControlCode;

  @ModelSync("value", "input", { type: String })
  syncedValue?: string;

  @Prop()
  placeholder?: string;
}
